import React, {useState, ReactChild, useEffect} from 'react';
import PropTypes from 'prop-types';
import {useTheme} from '@mui/material/styles';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Slide from '@mui/material/Slide';
import Link from '@mui/material/Link';
import {Topbar, Sidebar, Footer} from './components';
import Container from '../../common/Container';
import {pages} from '../navigation';
import {useTranslation} from 'react-i18next';
import {useLocation, useNavigate} from "react-router-dom";

const HideOnScroll = ({children}: { children: React.ReactElement<any, any> }) => {
    const trigger = useScrollTrigger();

    return (
        <Slide appear={false} direction="down" in={!trigger}>
            {children}
        </Slide>
    );
};

HideOnScroll.propTypes = {
    children: PropTypes.node.isRequired,
};

const Main = ({
                  children,
                  themeToggler,
                  themeMode,
                  setThemePalette,
                  paletteType,
              }: {
    children: ReactChild;
    themeToggler: () => void;
    themeMode: "light" | "dark";
    setThemePalette: (type?: string) => void;
    paletteType: string;
}) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const [openSidebar, setOpenSidebar] = useState(false);

    const handleSidebarOpen = () => {
        setOpenSidebar(true);
    };

    const location = useLocation()

    const [main, setMain] = useState(true);

    useEffect(() => {
        if (location.pathname === "/") {
            setMain(true)
        } else {
            setMain(false)
            setViewBoxHero(false)
        }
    }, [location.pathname]);

    const [viewBoxHero, setViewBoxHero] = React.useState(true);
    const heroEl = document.getElementById("hero");
    // const bodyEl = document.getElementsByTagName("body")[0] as HTMLElement;

    const isElementVisible = (ele: HTMLElement) => {
        const scrollTop = window.scrollY;
        const windowHeight = window.innerHeight;
        const eleTop = ele.offsetTop;
        const eleHeight = ele.offsetHeight;

        return (
            eleTop - scrollTop < windowHeight &&
            eleTop + eleHeight > scrollTop
        );
    }

    useEffect(() => {
        window.onscroll = () =>
            setViewBoxHero(!!heroEl && isElementVisible(heroEl))
        return () => {
            window.onscroll = null
        };
    });

    const handleSidebarClose = () => {
        setOpenSidebar(false);
    };

    return (
        <div>
            <HideOnScroll>
                <AppBar
                    position={'fixed'}
                    elevation={1}
                    sx={{backgroundColor: 'rgb(0,0,0,0)'}}
                >
                    <Box sx={{
                        backgroundColor: '#092038',
                    }}>
                        <Container paddingY={{xs: 1}}>
                            <Topbar
                                onSidebarOpen={handleSidebarOpen}
                                themeMode={themeMode}
                                themeToggler={themeToggler}
                                setThemePalette={setThemePalette}
                                paletteType={paletteType}
                            />
                        </Container>
                    </Box>
                    <Box sx={{
                        backgroundColor: viewBoxHero ? 'rgb(0,0,0,0)' : 'rgb(113, 133, 155, 1)',
                        border: 0,
                        boxShadow: 'none',
                        display: {xs: 'none', md: 'flex'}
                    }}>
                        <Container paddingY={2}>
                            <Box display="flex" justifyContent="end" alignItems={'center'} sx={{textAlign: 'center'}}>
                                <Box sx={{
                                    display: {xs: 'none', md: 'flex'},
                                    justifyContent: 'center',
                                    textAlign: 'center'
                                }} alignItems={'center'} gap={12}>
                                    <Box sx={{textAlign: 'center'}}>
                                        <Link
                                            underline="none"
                                            component="a"
                                            href="/page-announcements"
                                            color={"white"}
                                        >
                                            {t(pages[0].pages[4].title)}
                                        </Link>
                                    </Box>
                                    <Box sx={{textAlign: 'center'}}>
                                        <Link
                                            underline="none"
                                            component="a"
                                            href="/page-auctions"
                                            color={"white"}
                                        >
                                            {t(pages[0].pages[1].title)}
                                        </Link>
                                    </Box>
                                    <Box sx={{textAlign: 'center'}}>
                                        <Link
                                            underline="none"
                                            component="a"
                                            href="/page-documentation"
                                            color={"white"}
                                        >
                                            {t(pages[0].pages[2].title)}
                                        </Link>
                                    </Box>
                                    <Box>
                                        <Link
                                            underline="none"
                                            component="a"
                                            href="/page-contacts"
                                            color={"white"}
                                        >
                                            {t(pages[0].pages[3].title)}
                                        </Link>
                                    </Box>
                                </Box>
                            </Box>
                        </Container>
                    </Box>
                </AppBar>
            </HideOnScroll>
            <Sidebar
                onClose={handleSidebarClose}
                open={openSidebar}
                variant="temporary"
                pages={pages}
            />
            <main>
                <Box height={{xs: main ? 56 : 112}}/>
                {children}
                <Divider/>
            </main>
            <Container paddingY={4}>
                <Footer/>
            </Container>
        </div>
    );
};

Main.propTypes = {
    children: PropTypes.node,
    themeToggler: PropTypes.func.isRequired,
    themeMode: PropTypes.string.isRequired,
    setThemePalette: PropTypes.func.isRequired,
    paletteType: PropTypes.string.isRequired,
};

export default Main;
